import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountQuery } from 'restful/accounts/queries/useAccount';
import { RestApiError } from 'services/api/restful/errors';
import { deleteLinkedLoyaltyAccount } from 'services/api/restful/generated/accounts/accounts';

export const useDeleteSaudiRewardsAccount = () => {
  const queryClient = useQueryClient();

  const { isPending, isPaused, isError, mutate } = useMutation<
    void,
    RestApiError,
    void
  >({
    mutationFn: async () => {
      await deleteLinkedLoyaltyAccount();
    },
    onSuccess: () => {
      queryClient.setQueryData(accountQuery.queryKey, (oldData) => {
        if (!!oldData) {
          return {
            account: {
              ...oldData.account,
              saudiRewardsMemberId: null,
            },
          };
        }
      });
      queryClient.invalidateQueries({ queryKey: accountQuery.queryKey });
    },
  });

  return {
    deleteLinkedSaudiRewardsAccount: mutate,
    isLoading: isPending && !isPaused,
    isError,
  };
};
